import React from 'react';

const Sample2Preview = ({ content }) => {
  return (
    <div className="font-sans text-sm" style={{ fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div className="bg-slate-800 text-white p-6">
        <div className="flex items-center gap-4 mb-2">
          <div className="w-10 h-10 bg-emerald-600 rounded flex items-center justify-center font-bold text-lg">
            {content.header?.company_name?.charAt(0) || 'H'}
          </div>
          <div>
            <h1 className="text-lg font-bold">{content.header?.company_name || 'HOA Name'}</h1>
            <p className="text-xs text-slate-400">{content.header?.tagline || 'Quarterly Update'}</p>
          </div>
        </div>
        <h2 className="text-xl font-bold mt-4">
          {content.header?.title || 'Community Update'}
        </h2>
      </div>

      {/* Main Content */}
      <div className="p-6 space-y-6">
        {/* Summary Section */}
        <div>
          <h3 className="text-lg font-bold text-slate-800 mb-2">
            {content.summary?.title || 'Community Overview'}
          </h3>
          <p className="text-gray-700 leading-relaxed">
            {content.summary?.body || 'Add your community overview here...'}
          </p>
        </div>

        {/* Stats Section */}
        <div className="bg-slate-50 rounded-lg p-4">
          <h3 className="text-base font-bold text-slate-800 mb-3">
            {content.stats?.title || 'Key Statistics'}
          </h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white p-3 rounded shadow-sm">
              <p className="text-2xl font-bold text-emerald-600">0</p>
              <p className="text-xs text-gray-500">Active Members</p>
            </div>
            <div className="bg-white p-3 rounded shadow-sm">
              <p className="text-2xl font-bold text-slate-700">0</p>
              <p className="text-xs text-gray-500">Completed Projects</p>
            </div>
          </div>
        </div>

        {/* Forecast Section */}
        <div>
          <h3 className="text-lg font-bold text-slate-800 mb-2">
            {content.forecast?.title || 'Looking Ahead'}
          </h3>
          <p className="text-gray-700 leading-relaxed">
            {content.forecast?.body || 'Add your forecast and upcoming plans here...'}
          </p>
        </div>

        {/* Contact Section */}
        <div className="border-t pt-4">
          <h3 className="text-base font-bold text-slate-800 mb-3">
            {content.contact?.title || 'Contact Information'}
          </h3>
          <div className="grid grid-cols-2 gap-4">
            {content.contact?.members?.length > 0 ? (
              content.contact.members.map((member, index) => (
                <div key={index} className="flex gap-3">
                  <div className="w-12 h-12 bg-slate-200 rounded-full" />
                  <div>
                    <p className="font-medium text-sm">{member.name}</p>
                    <p className="text-xs text-gray-500">{member.role}</p>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-gray-500 text-sm col-span-2">Add contact members...</p>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-slate-100 p-4 text-center text-xs text-gray-500">
        <p>This newsletter is for informational purposes only.</p>
      </div>
    </div>
  );
};

export default Sample2Preview;
